<template>
    <div class="section-container w-100">
        <SectionTitle title="KPI Overview" />
        <KpiComparisonTable :kpiValues="sessionValues" :kpiComparison="sessionKpiComparison" valueLabel="match average"
            peakSpeedLabel="match maximum" />
    </div>
</template>


<script>
import SectionTitle from "@/components/SectionTitle.vue";
import KpiComparisonTable from "./KpiComparisonTable";
export default {
    props: {
        sessionKpiComparison: Object,
        sessionValues: Object
    },
    components: {
        SectionTitle,
        KpiComparisonTable
    },
};
</script>